import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import {Menu, X, ShieldCheck} from 'lucide-react'

export default function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  return (
    <nav className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <ShieldCheck className="w-8 h-8 text-blue-600" />
            <span className="text-xl font-bold text-slate-900">PluginsForWHMCS.com</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/plugins"
              className="text-slate-700 hover:text-blue-600 font-medium transition-colors"
            >
              Plugins
            </Link>
            <Link
              to="/wordpress-integration"
              className="text-slate-700 hover:text-blue-600 font-medium transition-colors"
            >
              WordPress
            </Link>
            <Link
              to="/elementor-whmcs"
              className="text-slate-700 hover:text-blue-600 font-medium transition-colors"
            >
              Elementor
            </Link>
            <Link
              to="/blog"
              className="text-slate-700 hover:text-blue-600 font-medium transition-colors"
            >
              Resources
            </Link>
            <a
              href="#"
              className="text-slate-700 hover:text-blue-600 font-medium transition-colors"
            >
              Support
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-slate-700"
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden border-t border-gray-200 py-4 space-y-1">
            <Link
              to="/plugins"
              className="block px-4 py-2 text-slate-700 hover:bg-blue-50 hover:text-blue-600 transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Plugins
            </Link>
            <Link
              to="/wordpress-integration"
              className="block px-4 py-2 text-slate-700 hover:bg-blue-50 hover:text-blue-600 transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              WordPress
            </Link>
            <Link
              to="/elementor-whmcs"
              className="block px-4 py-2 text-slate-700 hover:bg-blue-50 hover:text-blue-600 transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Elementor
            </Link>
            <Link
              to="/blog"
              className="block px-4 py-2 text-slate-700 hover:bg-blue-50 hover:text-blue-600 transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Resources
            </Link>
            <a
              href="#"
              className="block px-4 py-2 text-slate-700 hover:bg-blue-50 hover:text-blue-600 transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Support
            </a>
          </div>
        )}
      </div>
    </nav>
  )
}
